/* eslint-disable no-console */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MessageAlert from "../../shared/snack-bar/SnackBarMessage";
import { actions } from "../../../redux/actions/alert";

const Config = ({
  children,
  alert: { showAlert, message, severity, time },
}) => (
  <Fragment>
    {showAlert && (
      <MessageAlert message={message} time={time || 3000} severity={severity} />
    )}
    {children}
  </Fragment>
);

Config.propTypes = {
  alert: PropTypes.object.isRequired,
};

const dispatch = {
  addAlert: actions.addAlert,
};

const mapStateToProps = (state) => ({
  alert: state.alert,
});

export default connect(mapStateToProps, dispatch)(Config);
